import { call, put } from 'redux-saga/effects';
import Http from '../../libs/Http';

export function* fetchDynamicData(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });


  const data = yield call(Http.post, '/data/items', {
    body: {
      types: ['amazonAccounts'],
    }
  });


  yield put({
    // $global: true,
    type: 'SET_DYNAMIC_DATA',
    payload: {
      data,
    }
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* fetchAmazonBalances(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/data/amazonBalances', {});
  yield put({
    type: 'SET_AMAZON_BALANCES',
    payload: {
      amazonBalances: data.amazonBalances,
      rankedAccounts: data.rankedAccounts,
    },
  });
  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function* ({ takeFirst, takeLatest }) {
  yield [
    takeLatest('FETCH_DYNAMIC_DATA', fetchDynamicData),
    takeFirst('FETCH_AMAZON_BALANCES', fetchAmazonBalances),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/WorkArea.sagas.js